import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { PopoverController } from 'ionic-angular';
import { DetailPopoverMenu } from "../detailPopoverMenu/detailPopoverMenu";

@Component({
  selector: 'page-list',
  templateUrl: 'list.html',
  providers: [EbsWebService]
})
export class List {
  selectedItem: any;
  title: any;
  data: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private _ebsWebService: EbsWebService,
    public popoverCtrl: PopoverController) {

    this.title = navParams.get('title');
    this.selectedItem = navParams.get('item');
    if (typeof navParams.get('actionURL') != "undefined") {
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
      this.data = this._ebsWebService.postData(navParams.get('actionURL'), postPayloadObject);
      this.data.subscribe(res => console.log(res));
    }
    //events.publish("reloadMenu");
  }

  itemTapped(event, item) {
    console.log(item);
    this.navCtrl.push(List, {
      item: item
    });
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(DetailPopoverMenu, this.selectedItem);
    popover.present({
      ev: myEvent
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts